module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('measure-modal', {
    attrs: {
      "field-names": _vm.fieldNames,
      "measure_to_edit": _vm.measure_to_edit
    },
    on: {
      "reset": _vm.resetMeasureToEdit
    }
  }, [_c('button', {
    ref: "measure_modal",
    staticClass: "mb-2 ui blue button",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v(_vm._s(_vm.$t('Add a new measure')) + "\n      ")])]), _vm._v(" "), (_vm.customer.measures.length > 0) ? _c('div', {
    key: 'measure_list_' + _vm.customer.id,
    staticClass: "measure-list"
  }, [_c('datatable', {
    ref: "m_table",
    staticClass: "ui celled table left aligned fixed collapsing striped",
    attrs: {
      "column_widths": _vm.column_widths,
      "columns": _vm.measure_fields,
      "fetch": _vm.fetchData,
      "editable": true,
      "deletable": true,
      "duplicatable": true
    },
    on: {
      "delete_clicked": _vm.askDeleteMeasure,
      "edit_clicked": _vm.editMeasure,
      "duplicate_clicked": _vm.duplicateMeasure
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('popup-modal', {
    attrs: {
      "index": _vm.measure_to_delete,
      "icon": "delete",
      "cancel_class": "ui red basic cancel inverted button",
      "confirm_class": "ui green ok inverted button",
      "text": "Are you sure you want to delete this measure ?"
    },
    on: {
      "cancel": function($event) {
        _vm.measure_to_delete = null
      },
      "delete": _vm.deleteMeasure
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b0471c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/MeasurementTab.vue
// module id = 479
// module chunks = 1